import React from "react";
import { NavLink } from "react-router-dom";
import logo from "@/assets/images/logo.png";
import usersIcon from "@/assets/icons/users.svg";
import videoIcon from "@/assets/icons/videos.svg";
import musicIcon from "@/assets/icons/musics.svg";
import booksIcon from "@/assets/icons/books.svg";
import adminsIcon from "@/assets/icons/admins.svg";
import aiIcon from "@/assets/icons/AI.svg";
import styles from "./NavBar.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useGetCurrentAdminQuery } from "@/store/rtk-api/admin.api";
import { AdminRole } from "@/store/models/admin.models";
import storyTeller from "@/assets/icons/storyTeller.svg";
import featuredIcon from "@/assets/icons/featured-content.svg";

const navLinks = [
  { to: "/users", icon: usersIcon, alt: "Users" },
  { to: "/videos", icon: videoIcon, alt: "Video" },
  { to: "/songs", icon: musicIcon, alt: "Music" },
  { to: "/books", icon: booksIcon, alt: "Book" },
  { to: "/ai-prompts", icon: aiIcon, alt: "AI" },
  { to: "/story-teller/hero", icon: storyTeller, alt: "StoryTeller" },
  { to: "/featured-content", icon: featuredIcon, alt: "Featured Content" },
];

const NavBar = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const encodedEmail = encodeURIComponent(user?.email as string);
  const { data: adminData } = useGetCurrentAdminQuery(encodedEmail);

  return (
    <nav className={styles.nav}>
      <NavLink to={"/"}>
        <img className={styles.navLogo} src={logo} alt="logo" />
      </NavLink>

      {navLinks.map((link, index) => (
        <NavLink
          key={index}
          className={({ isActive }) =>
            isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
          }
          to={link.to}
        >
          <img className={styles.navIcon} src={link.icon} alt={link.alt} />
        </NavLink>
      ))}

      {adminData?.status === AdminRole.SUPER_ADMIN && (
        <NavLink
          className={({ isActive }) =>
            isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
          }
          to="/admins"
        >
          <img
            className={styles.navIcon}
            src={adminsIcon}
            alt="Admins"
            style={{
              marginLeft: "9px",
            }}
          />
        </NavLink>
      )}
    </nav>
  );
};

export default NavBar;

